
import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import { IsOptional, IsString, IsUUID, IsNumber, IsDateString, IsEnum } from 'class-validator';
import { PedagogicContentState, ContentVisibility } from "../../../enums/content.enum";
import { ChapterCapabilities } from "@sphere/shared/domain";
import { SubjectDto } from "../../subjects/response/subject.dto";
import { LevelDto } from "../../levels/response/level.dto";
import { ChapterProgramConceptDto } from '../../concept-links/response/chapter-program-concept.dto';
import { ChapterStatusDto } from '../../chapter-status/chapter-status.dto';
import { ChapterTeachingInChapterDto } from '../../chapter-teachings/response/chapter-teaching-in-chapter.dto';
import { ConceptDto } from '@sphere/curriculum/domain';

export class ChapterDto {
  @ApiProperty({ description: 'ID du chapitre', type: 'string' })
  @IsUUID()
  id: string;

  @ApiProperty({ description: 'Titre du chapitre', type: 'string' })
  @IsString()
  title: string;

  @ApiPropertyOptional({ description: 'Description du chapitre', type: 'string' })
  @IsOptional()
  @IsString()
  description?: string;

  @ApiPropertyOptional({ description: 'Heures estimées', type: Number })
  @IsOptional()
  @IsNumber()
  estimatedHours?: number;

  @ApiProperty({ enum: PedagogicContentState, description: 'État du chapitre' })
  @IsEnum(PedagogicContentState)
  state: PedagogicContentState;

  @ApiPropertyOptional({ description: 'ID du statut', type: () => ChapterStatusDto })
  @IsOptional()
  status?: ChapterStatusDto;

  @ApiPropertyOptional({ enum: ContentVisibility, description: 'Visibilité' })
  @IsOptional()
  @IsEnum(ContentVisibility)
  visibility?: ContentVisibility;

  @ApiProperty({ description: 'ID de la matière externe', type: 'string' })
  @IsString()
  subjectExternalId: string;

  @ApiPropertyOptional({ type: () => SubjectDto, description: 'Matière externe' })
  @IsOptional()
  subjectExternal?: SubjectDto;

  @ApiProperty({ description: 'ID du niveau externe', type: 'string' })
  @IsString()
  levelExternalId: string;

  @ApiPropertyOptional({ type: () => LevelDto, description: 'Niveau externe' })
  @IsOptional()
  levelExternal?: LevelDto;

  @ApiPropertyOptional({ description: 'Enseignements', type: () => [ChapterTeachingInChapterDto] })
  @IsOptional()
  teachings?: ChapterTeachingInChapterDto[];

  @ApiPropertyOptional({ description: 'Concepts associés', type: () => [ConceptDto] })
  @IsOptional()
  concepts?: ConceptDto[];

  @ApiPropertyOptional({
    description: 'IDs des ProgramConcepts associés au chapitre',
    type: [String],
  })
  @IsOptional()
  @IsUUID('4', { each: true })
  programConceptIds?: string[];

  @ApiPropertyOptional({ description: 'Nombre de leçons', type: Number })
  @IsOptional()
  @IsNumber()
  lessonsCount?: number;

  @ApiPropertyOptional({ description: 'Nombre de ressources', type: Number })
  @IsOptional()
  @IsNumber()
  resourcesCount?: number;

  @ApiPropertyOptional({ description: 'Nombre d\'enseignements', type: Number })
  @IsOptional()
  @IsNumber()
  teachingsCount?: number;

  @ApiProperty({ description: 'Date de création' })
  @IsDateString()
  createdAt: Date | string;

  @ApiProperty({ description: 'Date de mise à jour' })
  @IsDateString()
  updatedAt: Date | string;

  @ApiPropertyOptional({ description: 'Créateur', type: 'string' })
  @IsOptional()
  @IsString()
  createdByUserId?: string;

  @ApiPropertyOptional({ description: 'Modifié par', type: 'string' })
  @IsOptional()
  @IsString()
  updatedByUserId?: string;

  @ApiProperty({ description: 'Capabilities', type: Object, additionalProperties: true })
  capabilities: ChapterCapabilities;
}